// Textos accesibles de los botones y prefijos relativos de la fecha seleccionada.
export const DAILY_NAVIGATOR_TEXT = {
  PREVIOUS_DAY: 'Día anterior',
  NEXT_DAY: 'Día siguiente',
  SELECT_DAY: 'Seleccionar día',
  TODAY_PREFIX: 'Hoy - ',
  YESTERDAY_PREFIX: 'Ayer - '
}

// Formatos de fecha y configuración de posición del calendario del control diario.
export const DAILY_NAVIGATOR_CONFIG = {
  DATE_FORMAT: 'YYYY-MM-DD',
  SAME_YEAR_FORMAT: 'ddd D MMM',
  OTHER_YEAR_FORMAT: 'ddd D MMM YYYY',
  CALENDAR_Z_INDEX: 1300,
  CALENDAR_POSITION: 'bottom-start'
}
